import { render, staticRenderFns } from "./RequiredDocumentsInfo.vue?vue&type=template&id=3ec620c5&scoped=true"
import script from "./RequiredDocumentsInfo.vue?vue&type=script&lang=ts"
export * from "./RequiredDocumentsInfo.vue?vue&type=script&lang=ts"
import style0 from "./RequiredDocumentsInfo.vue?vue&type=style&index=0&id=3ec620c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec620c5",
  null
  
)

export default component.exports